import React from 'react';
import './style.css';
const Index = ({
    heading,
    isComp,
    name = 'Ronak Sarvaiya',
    add1 = '201',
    add2 = 'Shiv Sagar App.',
    add3 = 'Joshipura Sak Market',
    city = 'JUNAGADH',
    state = 'Gujarat',
    pin = '360001',
    country = 'India',
    phone = '+91-8153849384',
    email = 'ronaksarvaiya55555@gmail.com',
}) => {
    return (
        <div className="address_details">
            <h2 className="address_heading">{heading}</h2>
            <div className="address_details_content">
                <div className="address_details_content_partition">
                    {!isComp && <h4>{name}</h4>}
                    <p>{`${add1},${add2}`}</p>
                    <p>{add3}</p>
                    <p>{`${city} ${state} - ${pin}`}</p>
                    <p>{country}</p>
                    <h4>Telephone: </h4>
                    <p>{phone}</p>
                    <h4>Email:</h4>
                    <p>{email}</p>
                </div>
            </div>
        </div>
    );
};

export default Index;
